export default __webpack_public_path__ + "static/media/ucla-samueli-logo.2f6da69f.svg";